export default {
  NEW: `#graphql
  mutation newRefund($order: String!, $value: Int!, $type: String!, $method: String!, $observation: String, $account: String, $accountType: String, $accountOwnerDni: String, $accountOwnerDniType: String, $accountOwnerName: String) {
    newRefund(order: $order, value: $value, type: $type, method: $method, observation: $observation, account: $account, accountType: $accountType, accountOwnerDni: $accountOwnerDni, accountOwnerDniType: $accountOwnerDniType, accountOwnerName: $accountOwnerName)         
  }`,

  STAFF_REQUEST: `#graphql
  mutation staffRequestRefund($input: CustomerRequestRefundInput!, $sendNotifications: Boolean!) {
    staffRequestRefund(input: $input, sendNotifications: $sendNotifications) {
      success
      refundId
      bonus {
        bonus
        originalValue
        remainingValue
        status
        order
      }
    }
  }`,

  GET_BANKS: `#graphql
  query getBanks {
    getBanks {
      id
      description
    }
  }`,

  GET_REFUND_BANKS: `#graphql
  query getRefundBanks {
    getRefundBanks {
      id
      description
    }
  }`,

  GET_ALL: `#graphql
  query getRefunds($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getRefunds(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        refund,
        order,
        phones,
        status,
        value,
        method,
        type,
        account,
        accountOwnerName,
        accountOwnerDni,
        accountOwnerDniType,
        accountType,
        llave,
        llaveOwner,
        observations {
          observation,
          createdAt,
          createdBy
        },
        products {
          product
          size
          quantity
          reason,
          value,
          image
        }
        createdBy,
        createdAt,
        declinedBy,
        declinedAt,
        approvedAt,
        approvedBy
        refundedBy,
        refundedAt,
        brand,
        conveyorCustomer,
        tracking,
        packReceived,
        packReceivedAt,
        packReceivedBy,
        packageCost,
        receipts,
        notifications {
          refundEmailSent,
          refundWhatsappSent,
          history {
            platform,
            status,
            error,
            createdAt
          }
        }
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  ADD_OBSERVATION: `#graphql
  mutation addObservationRefund($refund: String!, $observation: String!) {
    addObservationRefund(refund: $refund, observation: $observation)        
  }`,

  UPDATE: `#graphql
  mutation UpdateRefund($refund: String!, $refundUpdate: RefundUpdateInput!) {
    updateRefund(refund:$refund, refundUpdate: $refundUpdate)
    {
      refund
    }            
  }`,

  DECLINE: `#graphql
  mutation declineRefund($refund: String!, $sendNotifications: Boolean!) {
    declineRefund(refund: $refund, sendNotifications: $sendNotifications)        
  }`,

  APPROVE: `#graphql
  mutation approveRefund($refund: String!, $sendNotifications: Boolean!) {
    approveRefund(refund: $refund, sendNotifications: $sendNotifications)        
  }`,

  DISAPPROVE: `#graphql
  mutation disapproveRefund($refund: String!, $sendNotifications: Boolean!) {
    disapproveRefund(refund: $refund, sendNotifications: $sendNotifications)        
  }`,

  REFUND: `#graphql
  mutation refundRefund($refund: String!) {
    refundRefund(refund: $refund)
  }`,

  SEND_NOTIFICATION: `#graphql
  mutation sendRefundNotification($refund: String!) {
    sendRefundNotification(refund: $refund)
  }`,

  RECEIVE_PACKAGE: `#graphql
  mutation receiveRefundPackage($refund: String!) {
    receiveRefundPackage(refund: $refund)
  }`,

  UNRECEIVE_PACKAGE: `#graphql
  mutation unreceiveRefundPackage($refund: String!) {
    unreceiveRefundPackage(refund: $refund)
  }`,

  DELETE_IMAGE: `#graphql
  mutation deleteImageRefund($refund: String!, $image: String!) {
    deleteImageRefund(refund: $refund, image: $image)
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/refund.js